import {IMapItemData} from "../../../../interface";

const template = require('./view/map.handlebars');

export class SquadMapitem {
  public constructor(private data: IMapItemData, private $wrapper: JQuery) {
    this.render();
  }

  /**
   * Append handlebars to $wrapper
   * Set click event on delete button
   */
  public render() {
    // render to $wrapper
    this.$wrapper.find('.mapcycle__maps').append(template({...this.data, imagePath: window.mapImagePath}));

    // set event
    $('.map[data-id="' + this.data.index + '"]').find('.map__delete').on('click', (e) => {
      // trigger custom event
      const event = new CustomEvent('removemap', {detail: {index: this.data.index}});
      window.dispatchEvent(event);
    });
  }
}
